import React from "react";
// import TableComandas from "../components/TableComandas";
import AppTurnoReactTable from "../table/AppTurnoReactTable";

import Footer from "../components/Footer";

import "../css/footer.css";

const Turnos = () => {
  return (
    <>
      <AppTurnoReactTable />
      {/* <TableComandas /> */}
      <Footer />
    </>
  );
};

export default Turnos;
